import { render, staticRenderFns } from "./ResetSetupFees.vue?vue&type=template&id=0ce54904&scoped=true&"
import script from "./ResetSetupFees.vue?vue&type=script&lang=js&"
export * from "./ResetSetupFees.vue?vue&type=script&lang=js&"
import style0 from "./ResetSetupFees.vue?vue&type=style&index=0&id=0ce54904&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0ce54904",
  null
  
)

export default component.exports